// extracted by mini-css-extract-plugin
module.exports = {"float-btn-wrap":"fv","floatBtnWrap":"fv","float-btn-snapping":"fw","floatBtnSnapping":"fw","float-btn-close":"fx","floatBtnClose":"fx"};